import React from "react";

import { LoadingIcon as Loading } from "@packages/ds";
import { useIntl } from "react-intl";

import * as S from "./DeleteBillingAlertBtn.styles";

import type { FormattedCost } from "@packages/client";

type DeleteBillingAlertBtnProps = {
  billingAlertThreshold?: FormattedCost;
  isBillingAlertLoading: boolean;
  isDeleteLoading: boolean;
  handleDeleteAlert: () => Promise<void>;
};

const DeleteBillingAlertBtn = ({
  billingAlertThreshold,
  isBillingAlertLoading,
  isDeleteLoading,
  handleDeleteAlert
}: DeleteBillingAlertBtnProps) => {
  const intl = useIntl();

  if (billingAlertThreshold) {
    if (isDeleteLoading && isBillingAlertLoading) {
      return (
        <S.LoadingDeleteWrapper>
          <Loading />
        </S.LoadingDeleteWrapper>
      );
    } else {
      return (
        <S.DeleteAlertButton
          variant="outline"
          type="button"
          aria-label={intl.formatMessage({
            id: "billing_alerts_modal.delete"
          })}
          onClick={handleDeleteAlert}
          disabled={isBillingAlertLoading}
        >
          {intl.formatMessage({ id: "billing_alerts_modal.delete" })}
        </S.DeleteAlertButton>
      );
    }
  }
  return null;
};

export default DeleteBillingAlertBtn;
